import React from 'react'
import { router } from '@inertiajs/react'
import Layout from '../../components/Layout'

const ROLES = [
  { value: 'admin', label: 'Administrador' },
  { value: 'editor', label: 'Pesquisador' },
  { value: 'visitor', label: 'Visitante' },
  { value: 'none', label: 'Aguardando aprovação' }
]

function RoleSelect({ userId, currentPermission }) {
  const handleChange = (e) => {
    const permission = e.currentTarget.value
    router.put(
      `/users/${userId}`,
      { permission },
      { preserveScroll: true, forceFormData: true }
    )
  }

  return (
    <select
      value={currentPermission || 'none'}
      onChange={handleChange}
      className="px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-brand-light focus:border-brand-light"
    >
      {ROLES.map((role) => (
        <option key={role.value} value={role.value}>
          {role.label}
        </option>
      ))}
    </select>
  )
}

function DeleteUserButton({ userId }) {
  const handleClick = () => {
    if (confirm('Essa ação não pode ser revertida. Você tem certeza?')) {
      router.delete(`/users/${userId}`, { preserveScroll: true })
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className="text-red-600 hover:text-red-800 hover:underline text-sm"
    >
      Deletar
    </button>
  )
}

function UserRow({ user }) {
  return (
    <tr className="border-b border-gray-100 last:border-0">
      <td className="py-3 px-4">
        <span className="font-semibold text-gray-800">{user.full_name}</span>
      </td>
      <td className="py-3 px-4 text-gray-500 text-sm">
        {user.email}
      </td>
      <td className="py-3 px-4">
        <RoleSelect userId={user.id} currentPermission={user.permission} />
      </td>
      <td className="py-3 px-4 text-right">
        <DeleteUserButton userId={user.id} />
      </td>
    </tr>
  )
}

export default function Admin({ admins, editors, visitors, unauthorized, cms_path }) {
  const allUsers = [
    ...(admins || []),
    ...(editors || []),
    ...(visitors || []),
    ...(unauthorized || [])
  ].sort((a, b) => a.full_name.localeCompare(b.full_name))

  return (
    <Layout>
      <div className="py-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-brand-dark mb-4 font-heading">
            Gerenciamento de Conteúdo
          </h1>
          <a
            href={cms_path}
            className="btn btn-primary"
          >
            Acessar Editor de Conteúdo
          </a>
        </div>

        <h1 className="text-2xl font-bold text-brand-dark mb-6 font-heading">
          Administração de Usuários
        </h1>

        {allUsers.length > 0 ? (
          <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">Nome</th>
                  <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">Email</th>
                  <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">Permissão</th>
                  <th className="py-3 px-4 text-right text-sm font-semibold text-gray-700">Ações</th>
                </tr>
              </thead>
              <tbody>
                {allUsers.map((user) => (
                  <UserRow key={user.id} user={user} />
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-12 text-gray-500">
            Nenhum usuário cadastrado além de você.
          </div>
        )}
      </div>
    </Layout>
  )
}
